// extracted by mini-css-extract-plugin
export var list = "Tags-module--list--ygAqj";
export var list__item = "Tags-module--list__item--BeJ7h";